export default __webpack_public_path__ + "static/media/routora-plus-visual.9ff170be.png";